<template>
  <main class="login-stage">
    <div class="login-orbit orbit-one" />
    <div class="login-orbit orbit-two" />
    <section class="login-story">
      <div class="brand-mark"><span>S</span></div>
      <p class="eyebrow">STARLIVE / GUILD OPERATIONS</p>
      <h1>让每一场直播<br><em>形成长期价值</em></h1>
      <p class="story-copy">主播关系、真实流水、等级成长与财务结算，在同一个可信的数据工作台中完成。</p>
      <div class="story-metrics">
        <div><strong>REAL</strong><span>只统计成功消费</span></div>
        <div><strong>UTC</strong><span>统一结算时间</span></div>
        <div><strong>AUDIT</strong><span>操作全程留痕</span></div>
      </div>
    </section>
    <section class="login-panel">
      <div class="login-panel-head">
        <span class="secure-dot" />
        <span>公会专属安全入口</span>
      </div>
      <h2>欢迎回来</h2>
      <p>使用平台审核后发放的账号登录</p>
      <el-form :model="form" @submit.native.prevent="submit">
        <el-form-item label="登录邮箱">
          <el-input v-model.trim="form.email" prefix-icon="el-icon-message" autocomplete="username" placeholder="name@guild.com" />
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" show-password autocomplete="current-password" placeholder="请输入密码" />
        </el-form-item>
        <div class="login-options">
          <el-checkbox v-model="remember">保持登录</el-checkbox>
          <span>账号由 StarLive 平台审核发放</span>
        </div>
        <el-button class="login-submit" type="primary" native-type="submit" :loading="loading">进入公会工作台 <i class="el-icon-right" /></el-button>
      </el-form>
      <div class="login-foot"><i class="el-icon-lock" /> 登录令牌经过加密保护，异常操作将被记录</div>
    </section>
  </main>
</template>

<script>
import { login } from "../api/guild"
import { setGuildToken } from "../api/request"

export default {
  name: "LoginView",
  data: () => ({ form: { email: "", password: "" }, remember: true, loading: false }),
  methods: {
    async submit() {
      if (!this.form.email || !this.form.password) return this.$message.warning("请输入邮箱和密码")
      this.loading = true
      try {
        const res = await login({ ...this.form, remember: this.remember ? 1 : 0 })
        setGuildToken(res.data.token)
        this.$emit("logged-in", res.data.account)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
